import Vue from "vue";
import myJsTools from "./myJsTools";
import {debounce} from "@/utils/debounce";

// 图片懒加载
console.log('vue 引入lazy')
var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
let io;
if (!isiOS) {
  io = new IntersectionObserver(arr => {
    arr.forEach(v => {
      // 获取元素
      let img = v.target;
      // 如果出现此元素
      if (v.isIntersecting) {
        // 赋值地址
        console.log(img.dataset.src + "==========img.dataset.src ");
        if (img.dataset.src.indexOf(".png") != -1 && img.dataset.src.indexOf(",") != -1) {
          myJsTools.getUrl(img.dataset.src).then(url => {
            console.log("isandriod" + url)
            img.src = url;
          })
        } else {
          img.src = img.dataset.src;
        }
        // 取消监听
        io.unobserve(img)
      }
    })
  })
}


// 注册一个全局自定义指令 `v-lazy`
Vue.directive('zlazy', {
  async inserted(el, binding) {
    // 如果存在图片地址
    if (el.dataset.type == 'jg') {
      el.src = require("../assets/img/index/jg.png");
    } else if (el.dataset.type == 'xyImg') {
      el.src = require("../assets/img/cf/xy.png");
    } else if (el.dataset.type == 'cyImg') {
      el.src = require("../assets/img/cf/cy.png");
    } else if(el.dataset.type === 'ignore') {
      el.src = ''
    } else {
      el.src = require("../assets/img/my/default.png");
    }
    if (binding.value) {
      el.dataset.src = binding.value;
      console.log(isiOS, "isiOS")
      if (isiOS) {
        if (el.dataset.src.indexOf(".png") != -1 && el.dataset.src.indexOf(",") != -1) {
          console.log(el.dataset.src, "isiOS")
          let s = await myJsTools.getUrl(el.dataset.src).then(url => {
            console.log("isiOS67" + url)
            el.src = url;
          })
        } else {
          el.src = el.dataset.src;
        }
      } else {
        io.observe(el)
      }
    } else {
      // 直接使用默认图片
      console.log('没有图片，替换默认图片')
    }
  }
})

// 指令【防抖】
Vue.directive("debounce", {
  // 只调用一次，第一次绑定元素时调用
  // el【绑定的元素】，binding【一个相关对象】，vnode【vue编译生成的虚拟节点】
  // beforemount之后，mounted之前；
  // init events&lifecycle 【初始化事件和生命周期】
  bind(el, binding, vnode, oldVnode) {
    console.log('34234', el, binding, vnode, oldVnode);
    let {value} = binding;
    let [target, time] = value;
    const debounced = debounce(target, time, vnode);
    el.addEventListener("click", debounced);
  },
  // 被绑定元素插入父节点时调用(仅保证父节点存在，但是不一定插入文档)
  inserted() {
  },
  // 所在组件的vnode更新时调用
  update() {
  },
  componentUpdated() {
  },
  unbind(el) {
    console.log(el, "el");
    el.removeEventListener("click", el._debounced);
  },
});

let globalZIndex = 3100;
Vue.directive('dialogDrag', {
  bind(el, binding) {
    const dragDom = el.querySelector('.el-dialog');
    if (!dragDom) return;
    
    dragDom.classList.add('v-drag-dialog-instance');
    const dialogHeaderEl = el.querySelector('.el-dialog__header');

    // 在指令 bind 阶段插入感应区
    const resizers = ['n', 's', 'e', 'w', 'nw', 'ne', 'sw', 'se'];
    resizers.forEach(type => {
      const div = document.createElement('div');
      div.className = `resizer ${type}`;
      div.dataset.type = type;
      dragDom.appendChild(div);
    });
    
    // 初始化样式
    dragDom.style.position = 'absolute';
    dragDom.style.height = '80vh';
    dragDom.style.margin = '0'; 
    dialogHeaderEl.style.cursor = 'move';
    // 鼠标移到到dialogHeaderEl，提示文字“可拖拽移动”
    dialogHeaderEl.setAttribute('title', '按住移动');

    // --- 1. 阶梯定位逻辑 (保持不变) ---
    const calcStepPosition = () => {
      let left = window.innerWidth / 4;
      let top = 100;
      const step = 50;
      const existingDialogs = document.querySelectorAll('.v-drag-dialog-instance');
      const positions = Array.from(existingDialogs)
        .filter(d => d !== dragDom && d.style.display !== 'none')
        .map(d => ({ left: parseInt(d.style.left), top: parseInt(d.style.top) }));

      let isOverlap = true;
      while (isOverlap) {
        isOverlap = positions.some(p => Math.abs(p.left - left) < 10 && Math.abs(p.top - top) < 10);
        if (isOverlap) { left += step; top += step; }
        if (left > window.innerWidth - 200 || top > window.innerHeight - 200) {
          left = 100; top = 100; break; 
        }
      }
      dragDom.style.left = left + 'px';
      dragDom.style.top = top + 'px';
    };

    calcStepPosition();

    // --- 2. 层级管理 ---
    const setIndex = () => {
      const currentZ = parseInt(dragDom.parentNode.style.zIndex || 0);
      if (currentZ < globalZIndex) {
        globalZIndex++;
        dragDom.parentNode.style.zIndex = globalZIndex;
      }
    };
    setTimeout(() => { setIndex(); }, 60);

    // --- 3. 拖拽与边界控制 ---
    dragDom.onmousedown = (e) => {
      // --- 新增：只允许左键拖拽 (0: 左键, 1: 中键, 2: 右键) ---
      if (e.button !== 0) return;
      setIndex();

      // --- 性能优化：在按下时缓存容器尺寸，避免在 move 中频繁读取 ---
      const screenWidth = document.documentElement.clientWidth;
      const screenHeight = document.documentElement.clientHeight;
      const headerHeight = dialogHeaderEl.offsetHeight;
      const dragDomWidth = dragDom.offsetWidth;
      const dragDomHeight = dragDom.offsetHeight;

      const disX = e.clientX - dragDom.offsetLeft;
      const disY = e.clientY - dragDom.offsetTop;
      

      const rect = dragDom.getBoundingClientRect();
      const { clientX: startX, clientY: startY } = e;
      const { offsetWidth: startW, offsetHeight: startH, offsetLeft: startL, offsetTop: startT } = dragDom;
      // const resizeTouchSize = 12;
      // const isRight = rect.right - e.clientX < resizeTouchSize;
      // const isBottom = rect.bottom - e.clientY < resizeTouchSize;
      // const isDrag = e.target === dialogHeaderEl || dialogHeaderEl.contains(e.target);
      // 获取当前鼠标指针样式，判断缩放方向
      const curCursor = getComputedStyle(e.target).cursor;
      const isResizing = curCursor.includes('resize');
      const curCursorType = e.target.dataset.type;
      // 再加个判断 不能是关闭按钮或者关闭icon
      const isDrag = !isResizing && (e.target === dialogHeaderEl || (!['BUTTON','I'].includes(e.target.nodeName) && dialogHeaderEl.contains(e.target)));

      if (!isResizing && !isDrag) return;

      // 预计算边界值，减少移动中的逻辑计算量
      // 左右限制：至少保留 100px 在可见区
      // 最小值：- (宽度 - 100)
      // 最大值：屏幕宽度 - 100
      const minLeft = -(dragDomWidth - 100);
      const maxLeft = screenWidth - 100;
      // 上下限制：Header 不可出界
      // 最小值：0 (顶部)
      // 最大值：屏幕高度 - Header高度
      const minTop = 0;
      const maxTop = screenHeight - headerHeight;

      document.onmousemove = (moveE) => {
        moveE.preventDefault();
        
        // 场景 A：缩放
        const dx = moveE.clientX - startX;
        const dy = moveE.clientY - startY;

        if (isResizing) {
          let newW = startW;
          let newH = startH;
          let newL = startL;
          let newT = startT;
          console.log('curCursor', curCursor);
          // --- 1. 水平缩放逻辑 ---
          if (curCursorType.includes('e')) { // 拉右边：左边不动
            newW = startW + dx;
            // 限制：右边缘不能缩过头，且不能超出屏幕过远（如果需要）
            if (newL + newW < newL + 200) newW = 200; 
            // 保持 100px 在内逻辑：newW + newL 不能小于 100
            if (newL + newW < 100) newW = 100 - newL;
          } 
          else if (curCursorType.includes('w')) { // 拉左边：右边不动
            newW = startW - dx;
            newL = startL + dx;
            console.log('newL', newL);
            // 最小宽度限制
            if (newW < 200) {
              newL = startL + (startW - 200);
              newW = 200;
            }
            // 边界限制：左边拉出去后，右侧必须剩 100px 在屏幕内
            if (newL > screenWidth - 100) {
              newL = screenWidth - 100;
              newW = startW + (startL - newL);
            }
          }

          // --- 2. 垂直缩放逻辑 ---
          if (curCursorType.includes('s')) { // 拉下边：上边不动
            newH = startH + dy;
            if (newH < 150) newH = 150;
            // 限制底部不穿透屏幕底部
            if (newT + newH > screenHeight) newH = screenHeight - newT;
          } 
          else if (curCursorType.includes('n')) { // 拉上边：下边不动
            newH = startH - dy;
            newT = startT + dy;
            // 最小高度限制
            if (newH < 150) {
              newT = startT + (startH - 150);
              newH = 150;
            }
            // 边界限制：Header 不可出顶
            if (newT < 0) {
              newT = 0;
              newH = startH + (startT - 0);
            }
          }

          // --- 边界与最小尺寸限制 ---
          const minW = 200, minH = 150;
          if (newW < minW) {
            if (curCursorType.includes('w')) newL = startL + (startW - minW);
            newW = minW;
          }
          if (newH < minH) {
            if (curCursorType.includes('n')) newT = startT + (startH - minH);
            newH = minH;
          }
          if (curCursorType.includes('n')) {
            newT = Math.max(0, startT + dy); // 禁止 Header 移出顶部
            newH = startH + (startT - newT); // 高度增量 = 原坐标与新坐标的差
          }

          // 应用样式
          dragDom.style.width = newW + 'px';
          dragDom.style.height = newH + 'px';
          dragDom.style.left = newL + 'px';
          dragDom.style.top = newT + 'px';

        } 
        // 场景 B：移动 (加入边界限制)
        else if (isDrag) {
          let left = moveE.clientX - disX;
          let top = moveE.clientY - disY;

          if (left < minLeft) left = minLeft;
          if (left > maxLeft) left = maxLeft;

          if (top < minTop) top = minTop;
          if (top > maxTop) top = maxTop;

          dragDom.style.left = `${left}px`;
          dragDom.style.top = `${top}px`;
        }
      };

      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
